var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-results"},[(_vm.getTotalResults > 0)?_c('span',{staticClass:"page-results__indicator"},[_vm._v(" "+_vm._s(_vm.getLowerPageResultRange)+"-"+_vm._s(_vm.getUpperPageResultRange)+" out of "+_vm._s(_vm.getTotalResults)+" results ")]):_c('span',{staticClass:"page-results__indicator"},[_vm._v(" 0 results ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }